module.exports = __webpack_public_path__ + "img/stop_btn.f9f4a5c2.png";